import React, { useContext, useRef, useState } from 'react';

import Card from '../../../../Base/Components/Card/Card';
import Loader from '../../../../Base/Components/Loader/Loader';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { Button } from 'primereact/button';
import { getDatesHorarioNormal } from '../../../../Base/Services/Moment/Luxon';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import CalendarioMensual from '../../../../Base/Components/CalendarioMensual/CalendarioMensual';
import { getPagosProveedoresEncFechasWere } from '../../../../APIPR/CuentasPorPagar/PagosProveedores/PagosProveedoresRequest'
// import { getPagosProveedoresEncFechas } from '../../../../API/Compras/PagoProveedores/PagosProveedoresRequest';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import ModalPagosProveedores from './ModalPagosProveedores'

const PagosProveedoresScreen = () => {
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [selected, setSelected] = useState([]);
    const [IdCalendario, setIdCalendario] = useState(null);
    const [dialogPago, setDialogPago] = useState(false);
    const [IdPago, setIdPago] = useState(0);

    const { userAuth } = useContext(AuthContext);

    const safeSetData = (result) => {
    setData(Array.isArray(result) ? result : []);
    };

    const hideDialog = () => {
    setDialogPago(false);
    };

    const openPago = (Id) => {
        setIdPago(Id)
        setDialogPago(true)
    }

    const EstadoTemplate = (rowData) => {
        switch (rowData.IdEstado) {
            case 2070:
                return <Tag style={{ width: 100, backgroundColor: "#9cb1cf" }} value={rowData.Estado} />;
            case 2071:
                return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.Estado} />;
            case 2072:
                return <Tag style={{ width: 100, backgroundColor: "#cf494b" }} value={rowData.Estado} />;
            case 2076:
                return <Tag style={{ width: 100, backgroundColor: "#cf494b" }} value={rowData.Estado} />;
            case 2117:
                return <Tag style={{ width: 100, backgroundColor: "#ddb533" }} value={rowData.Estado} />
            default:
                return <span>{rowData.Estado}</span>;
        }
    };

    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'IdPago',
                header: 'IdPago',
                headerEn: 'IdPago',
                className: 'Xsmall',
                width: 60,
                hidden: userAuth.IdRol === 1,
                frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'NumeroPago',
                header: 'Numero Pago',
                headerEn: 'Payment Number',
                Format: 'Center',
                className: 'small',
                onCellDoubleClicked: ({ data }) => {
                    if (data.IdPago) {
                        openPago(data.IdPago)
                    }
                },
                Sumary: 'count',
                frozen: true,
                alignFrozen: 'left',
                sort: 'desc'
            },
            {
                field: 'Estado',
                header: 'Estado',
                headerEn: 'Status',
                className: 'small',
                Format: 'Template',
                body: rowData => EstadoTemplate(rowData),
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'Fecha',
                header: 'Fecha Pago',
                headerEn: 'Payment Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'Proveedor',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'XXlarge',
            },
            {
                field: 'Currency',
                header: 'Moneda',
                headerEn: 'Currency',
                className: 'small',
            },
            {
                field: 'TasaCambio',
                header: 'TasaCambio',
                headerEn: 'TasaCambio',
                className: '',
            },
            {
                field: 'TipoPago',
                header: 'TipoPago',
                headerEn: 'Payment Type',
                className: 'medium',
            },
            {
                field: 'Memo',
                header: 'Memo',
                headerEn: 'Memo',
                className: 'XXXlarge',
            },
            {
                field: 'Cuenta',
                header: 'Cuenta Banco',
                headerEn: 'Bank Account',
                className: 'XXlarge',
            },
            {
                field: 'CuentaPrincipal',
                header: 'Cuenta',
                headerEn: 'Account',
                className: '',
            },
            {
                field: 'IsCobroComisionProveedor',
                header: 'Comision Proveedor',
                headerEn: '',
                className: 'small',
                Format: 'Checkbox',
            },
            {
                headerName: "Lempiras",
                children: [
                    {
                        field: 'DescuentoL',
                        header: 'DescuentoL',
                        headerEn: 'DescuentoL',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                    {
                        field: 'CreditoL',
                        header: 'CreditoL',
                        headerEn: 'CreditoL',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                    {
                        field: 'ComisionL',
                        header: 'ComisionL',
                        headerEn: 'ComisionL',
                        className: 'small',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                ]
            },
            {
                headerName: "Dolares",
                children: [
                    {
                        field: 'DescuentoD',
                        header: 'DescuentoD',
                        headerEn: 'DescuentoD',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                    {
                        field: 'CreditoD',
                        header: 'CreditoD',
                        headerEn: 'CreditoD',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                    {
                        field: 'ComisionD',
                        header: 'ComisionD',
                        headerEn: 'ComisionD',
                        className: 'small',
                        Format: 'Currency',
                        Sumary: 'sum'
                    },
                ]
            },
            {
                field: 'UsuarioEnvioCorreo',
                header: 'Usuario Correo',
                headerEn: 'Email User',
                className: 'small',
            },
            {
                field: 'EmailDate',
                header: 'Fecha Envío',
                headerEn: 'Email Date',
                className: 'Xsmall',
                Format: 'DateTime',
            },
            {
                field: 'MontoL',
                header: 'Monto L',
                headerEn: 'Amount Lps',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'MontoD',
                header: 'Monto $',
                headerEn: 'Amount $',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'IdUsuarioEnvioCorreo',
                header: 'Correo Enviado',
                headerEn: 'Email Sent',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.IdPago ? (
                    <div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={data?.IdUsuarioEnvioCorreo > 0 ?? false} disabled />
                    </div>
                ) : null,
            },
        ]
    };
    

    return (
        <div>
            <Loader loading={loading} querySelector={'#PagosProveedoresScreen'} />
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card
                titulo={
                    <div className='d-flex gap'>
                        <CalendarioMensual
                            getInfo={getPagosProveedoresEncFechasWere}
                            data={data}
                            setData={safeSetData}
                            selected={selected}
                            setSelected={setSelected}
                            dates={dates}
                            setDates={setDates}
                            loading={loading}
                            setLoading={setLoading}
                            setIdCalendario={setIdCalendario}
                            IdCalendario={IdCalendario}
                        />
                        <Button icon='pi pi-plus' onClick={() => { setIdPago(0); setDialogPago(true); }} style={{ height: 35 }} />
                    </div>
                    
                }
                contenido={
                    <div className='pt-4' style={{ height: '85vh' }} id='PagosProveedoresScreen'>
                        <AgGrid table={table} />
                    </div>
                }
            />

            <ModalPagosProveedores
            dialogPago={dialogPago}
            hideDialog={hideDialog}
            IdPago={IdPago}
            />
        </div>
    );

};

export default PagosProveedoresScreen;